<template>
  <div :style="style" @mouseover="mouseOver()"  class="panel">
    <div class="panel-heading">{{ title }}</div>
    <div :style="bodyStyle" class="panel-body">
      {{ content }}
      <component :is="passedComponent"></component>
    </div>
  </div>
</template>

<script>
import RegistrationForm from './RegistrationForm.vue'

export default {
  name: 'Panel',
  props: {
    icon: String,
    title: String,
    content: String,
    width: Number,
    height: Number,
    posX: Number,
    posY: Number,
    startX: Number,
    startY: Number,
    passedComponent: {
      type: [String, Object],
      default: 'div',
    },
  },
  components: {
    RegistrationForm
  },
  computed: {
    style () {
      var css = {};
      if(this.height) css["height"] = this.height + "%";
      if(this.width) css["width"] = this.width + "%";
      if(this.posX) css["left"] = this.posX + "%";
      if(this.posY) css["top"] = this.posY + "%";
      if(this.hovering) {
        css["background-color"] = "rgb(125,125,125)";
        css["color"] = "rgb(5,20,10)";
      }
      return css;
    },
  //  bodyStyle () {
//      return {"background-color": this.hovering ? "rgb(75,75,75)" : "rgb(99,99,99)"};
    //}

  },
  data () {
    return {
      hovering: false
    }
  },
  methods: {
    mouseOver () {
      this.hovering = !this.hovering
    }
  }
}
</script>

<style scoped>
.panel {
  transition: all 0.5s cubic-bezier(0.71, 0.25, 0.02, 1);
  padding:0px;
  position:absolute;
  border-color: rgb(70,70,70);
  color: rgb(10,40,20);
  background-color:rgb(99,99,99);
  left: -300px;
  /* top: 25%; */
  white-space: pre-line;
  overflow-wrap: break-word;
  width: 300px;
  box-shadow: 3px 3px 8px 3px rgb(10,10,10);
}
.grid-y-focus.grid-x-focus .panel {
  /* left: 25%!important; */
}
.panel-heading {
  padding: 5px 20px;
  background-color:rgb(90,90,90);
}
.panel-body {
  margin:20px;
}
</style>
